// noinspection DuplicatedCode

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Card from "@material-tailwind/react/Card";
// import { SearchBarSmall, SearchBarSmallV2 } from "../form/SearchBar";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import {
  fetchPost,
  fetchPostSilance,
  fetchGet,
  fetchPostMultipartSeaweed,
} from "../../../fetchers";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import TableMemoAll from "../../../components/tablecard/TableMemoAll";
import { TextEditor } from "./TextEditor";

import {
  GetKaryawanMinV2,
  getMinKaryawan,
  karyawanSelector,
} from "../../hrd/karyawan/karyawanSlice";
import {
  //   getIzinTransaksi,
  //   insertIzinTransaksi,
  izinTransaksiSelector,
  updateIzinTransaksi,
} from "../../hrd/transaksi/izin/izinTransaksiSlice";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../hrd/karyawan/KaryawanSelector";
import { bagianSelector, getMinBagian } from "../../master/bagian/bagianSlice";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { convertToRaw, EditorState } from "draft-js";

const MemoPageAll = ({}) => {
  let initialState = {
    Bulan: new Date(),
    to: [], // Changed to array to support multiple select
  };
  const mutation = useMutation((param) => fetchGet("getInternalReportAll", param));

  const mutationAdd = useMutation((param) =>
    fetchPost("InsertInternalMemo", param)
  );

  const validations = [
    ({ to }) => (to && to.length > 0) || { to: "To wajib diisi" }, // Updated validation for array
    ({ Subject }) => isRequired(Subject) || { Subject: "Subject wajib diisi" },
    ({ Attachment }) =>
      isRequired(Attachment) || { Attachment: "Attachment wajib diisi" },
    ({ description }) =>
      isRequired(description) || { Description: "Description wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
    changeArrayHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dateChanged, setDateChanged] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );
  const userString = localStorage.getItem("user");
  let authUser = null;

  if (userString) {
    try {
      const userObj = JSON.parse(userString);
      authUser = userObj?.Nik; // "SO-20220601"
    } catch (err) {
      console.error("Failed to parse user from localStorage", err);
    }
  }

  useEffect(() => {
    const formData = {
      start: start,
      count: count,
      search: "",
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      user: authUser, // Kirim user ID ke backend
      showall: "false", // Default hanya tampilkan memo terkait user
    };
    mutation.mutate(formData);
  }, []);

  const reapprove = () => {
    mutation.mutate({
      start: start,
      count: count,
      search: search,
    });
  };

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 10,
      search: searchValue,
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
    };
    mutation.mutate(params);
    setStart(0);
    setCount(10);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function ClickAdd() {
    setShowModalAdd(true);
    clearHandler();
    setButtonTouched(false);
    dispatch(getMinBagian({ search: "" }));
    dispatch(GetKaryawanMinV2({ search: "" }));
  }

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      console.log(currentData);
    }
  }, [showModalEdit]);

  const Kirim = () => {
    if (values["NamaFile"]) {
      try {
        const { v4: uuidv4 } = require("uuid");
        const uuid = uuidv4();
        let formData = new FormData();
        const nama = uuid + "-" + values["NamaFile"].name.replaceAll(" ", "_");
        formData.append("file", values["NamaFile"], nama);
        mutationFile.mutate(formData);
        values["NamaFile"] = nama;
      } catch (error) {
        console.log(error);
      }
    }

    // Siapkan data yang akan dikirim
    const memoData = {
      to: values.to, // Array penerima utama
      cc: values.Cc, // Array penerima CC
      subject: values.Subject,
      desc: values.description,
      file: values.NamaFile,
    };

    mutationAdd.mutate(memoData, {
      onSuccess: async (data, context) => {
        toast.success(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShowModalAdd(false);
        setShowModalEdit(false);
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      },
      onError: async (data, context) => {
        toast.error(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      },
    });
  };

   const filterApi = () => {
    const formData = {
      start: start,
      count: count,
      search: "",
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      user: authUser, // Kirim user ID ke backend
      showall: "false" // Default hanya tampilkan memo terkait user
    };
    mutation.mutate(formData);
  };

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
    dispatch(getMinKaryawan({ search: "" }));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Bulan"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>
                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                  <div className={"w-1/4"}>
                    {/* <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Cari data
                    </label> */}
                    {/* <input
                      type="text"
                      onChange={(e) => {
                        setSearch(e.target.value);
                        handleSearch(e.target.value);
                      }}
                      value={search}
                      className="appearance-none block w-full  text-gray-700 border border-black-500 rounded py-2 px-4 mb-2 leading-tight outline-none bg-white"
                      placeholder={"Search "} */}
                    {/* // autoComplete="on" */}
                    {/* /> */}
                    
                  </div>
                </div>
                <TableMemoAll
                  usingMutation={true}
                  mutation={mutation}
                  primaryID="ID"
                  transaksi={true}
                  addButtonTambah={true}
                  tableData={mutation.data}
                  handleSearch={handleSearch}
                  searchPlaceholder="Memo"
                  OnClick={ClickAdd}
                  modal={handleModal}
                  currentData={handleCurrentData}
                />
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        fullscreen={true}
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <HrdInputGenerator
              type={"multipleSelect"}
              value={values}
              name={"to"}
              title={"To"}
              onChange={changeArrayHandler} // Using changeArrayHandler for multiple select
              touched={touched}
              buttonTouched={buttonTouched}
              size={"full"}
              required={true}
              errors={errors}
              disabled={false}
            />

            <HrdInputGenerator
              type={"multipleSelect"}
              value={values}
              currentData={currentData}
              name={"Cc"}
              title={"Cc"}
              onChange={changeArrayHandler}
              touched={touched}
              buttonTouched={buttonTouched}
              size={"full"}
              required={true}
              errors={errors}
              disabled={false}
            />

            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Subject *
              </label>
              <input
                value={values.Subject}
                onChange={changeHandler}
                name="Subject"
                className={
                  (touched.Subject || buttonTouched) && errors.Subject
                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                }
                type="text"
                disabled={showModalEdit ? true : false}
              />
            </div>

            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-6">
                {values["NamaFile"] && "Ganti "}
                Attachment
              </label>
              <label
                htmlFor={"NamaFile"}
                className="block w-full border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              >
                {values["NamaFile"] ? (
                  <span>
                    File Selected -{" "}
                    {values["NamaFile"].name
                      ? values["NamaFile"].name
                      : values["NamaFile"]}
                  </span>
                ) : (
                  <span>Choose a file...</span>
                )}
              </label>

              <input
                type="file"
                id={"NamaFile"}
                key={"NamaFile"}
                name={"NamaFile"}
                style={{ visibility: "hidden" }}
                className="block  border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                onChange={(e) => {
                  customHandler(e.target.files[0], "NamaFile");
                }}
              />
            </div>
            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Description
              </label>
              <TextEditor
                onClick={changeHandler}
                onChange={(e) =>
                  customHandler(
                    draftToHtml(convertToRaw(e.getCurrentContent())),
                    "description"
                  )
                }
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              isValid || (showModalEdit && dateChanged && !isValid)
                ? "green"
                : "blueGray"
            }
            onClick={() => Kirim()}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MemoPageAll;
